/* global axios */
import ApiClient from './ApiClient';

class ContactMeetingsAPI extends ApiClient {
  constructor() {
    super('contacts', { accountScoped: true });
  }

  getMeeting(contactId, meetingId) {
    return axios.get(`${this.url}/${contactId}/meetings/${meetingId}`);
  }

  recordDemoStatus(contactId, meetingId, payload) {
    return axios.post(
      `${this.url}/${contactId}/meetings/${meetingId}/record_demo_status`,
      payload
    );
  }
}

export default new ContactMeetingsAPI();
